export default __webpack_public_path__ + "static/media/hero-image-5.4e4c55e9.svg";